import {
  action$,
  persistentDerivedStream,
  persistentReducedStream,
  reducer,
  reduceState,
  streamReducer,
} from '@ardoq/rxbeach';
import { hideRightPane, showRightPane } from 'appContainer/actions';
import { combineLatest } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { returnPayload, returnFalse, returnTrue } from '@ardoq/common-helpers';
import { focusedChrome$ } from 'scope/focusedChrome$';
import { focusedChromeOperations } from 'scope/focusedChromeOperations';

const isOpen$ = action$.pipe(
  reduceState('isOpen', false, [
    reducer(showRightPane, returnTrue),
    reducer(hideRightPane, returnFalse),
  ]),
  debounceTime(32),
  distinctUntilChanged()
);

const isRightEditorPaneOpenRequested$ = persistentReducedStream<boolean>(
  'isRightEditorPaneOpenRequested$',
  false,
  [streamReducer(isOpen$, returnPayload)]
);

/**
 * The pane is the app's editor, and a read-only visualization offers no control
 * to open or close one. Refused here as well as at the pane itself because
 * `appLayout$` narrows the visualization to make room from this value alone, so
 * a request that renders nothing would still shrink the view.
 */
export const isRightEditorPaneOpen$ = persistentDerivedStream(
  'isRightEditorPaneOpen$',
  combineLatest([isRightEditorPaneOpenRequested$, focusedChrome$]).pipe(
    map(
      ([isRightEditorPaneOpenRequested, focusedChrome]) =>
        isRightEditorPaneOpenRequested &&
        !focusedChromeOperations.isReadOnlyVisualization(focusedChrome)
    ),
    distinctUntilChanged()
  ),
  false
);
